export default __webpack_public_path__ + "static/sns-instagram-44b51bfaf36445fbd6e5df7ab6b7d132.svg";